import MyCustomerTable from './src/vueComponents/MyCustomerTable';
MyCustomerTable.install = (Vue)=>{
    Vue.components(MyCustomerTable.name,MyCustomerTable)
}
export default MyCustomerTable;
